var map = {
	".": 340,
	"./": 340,
	"./Component": 1068,
	"./Component.js": 1068,
	"./OldUi": 1069,
	"./OldUi.js": 1069,
	"./RenderComponent": 780,
	"./RenderComponent.js": 780,
	"./TopActions": 779,
	"./TopActions.js": 779,
	"./index": 340,
	"./index.js": 340,
	"./style": 435,
	"./style.js": 435
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4244;
module.exports = webpackAsyncContext;